export default __webpack_public_path__ + "static/media/ic_menu.d810b3dd.svg";